export const COOKIE_WC_HEIGHT = "wc-height";